<template>
  <div data-scroll-container>
    <div data-scroll-section>
      <div class="elfsight-app-19e3ae0f-19be-474a-a173-d81a74c5c8ba text-center mb-12" data-elfsight-app-lazy></div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://elfsightcdn.com/platform.js')
    externalScript.setAttribute('defer', 'defer')
    document.head.appendChild(externalScript)
    this.$root.setLoaderPercentage(100)
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch('togglePageReady', true)
    }, this.$root.loaderCountDuration - 2000)
  },
}
</script>

<style lang="scss">
@import 'src/sass/variables';
@import 'src/sass/mixins';
@import 'node_modules/bootstrap/scss/vendor/rfs';
</style>